import React, { useState } from "react";
import "./NewDashboardRoutePage.css";
import { useHistory } from "react-router-dom";
import DEATH_API from "../../apis/death.api";
import { Spin } from "antd";
import peopleSadImage from "../../assets/images/people.png";
import education from "../../assets/images/education.png";
import goalImage from "../../assets/images/goal.png";
import concertImage from "../../assets/images/concert.png";

const NewDashboardRoutePage = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const dashboardCardsData = [
    {
      title: "The Chief",
      description: "Goal-Oriented Risk-Taking Good Under Stress",
      route: "/dashboard",
      image: goalImage,
      defaultUserSetting: {
        dashboard1DragCards: [
          { id: "ChatComponentDashboard" },
          { id: "IncomeAndExpensChart" },
          { id: "UpcomingBillsTable" },
          { id: "DashboardCalendar" },
          { id: "InvestmentWatchlistTable" },
          { id: "budgetExpanse" },
          { id: "goalProgress" },
          { id: "dashboardGoalCharts" },
          { id: "DashboardSavingsGoal" },
          { id: "PortfolioBalancesTable" },
          { id: "LatestNews" },
          { id: "topMonthlyExpanse" },
          { id: "TasksList" },
          { id: "dashboardGoalSection" },
          { id: "StoredDocumentsTable" },
          { id: "TwitterFeeds" },
        ],

        dashboard2DragCards: [
          { id: "UpcomingBillsTable" },
          { id: "dashboardGoalSection" },
          { id: "DashboardCalendar" },
          { id: "InvestmentWatchlistTable" },
          { id: "goalProgress" },
          { id: "PortfolioBalancesTable" },
          { id: "IncomeAndExpensChart" },
          { id: "ChatComponentDashboard" },
          { id: "dashboardGoalCharts" },
          { id: "DashboardSavingsGoal" },
          { id: "LatestNews" },
          { id: "budgetExpanse" },
          { id: "topMonthlyExpanse" },
          { id: "TasksList" },
          { id: "TwitterFeeds" },
          { id: "StoredDocumentsTable" },
        ],
        dashboard3DragCards: [
          { id: "topMonthlyExpanse" },
          { id: "DashboardSavingsGoal" },
          { id: "UpcomingBillsTable" },
          { id: "PortfolioBalancesTable" },
          { id: "dashboardGoalSection" },
          { id: "DashboardCalendar" },
          { id: "IncomeAndExpensChart" },
          { id: "goalProgress" },
          { id: "InvestmentWatchlistTable" },
          { id: "ChatComponentDashboard" },
          { id: "dashboardGoalCharts" },
          { id: "LatestNews" },
          { id: "budgetExpanse" },
          { id: "TasksList" },
          { id: "TwitterFeeds" },
          { id: "StoredDocumentsTable" },
        ],
      },
    },
    {
      title: "The Socializer",

      description: "RelationShip-oriented Outgoing Enthusiastic",
      route: "/dashboard",
      image: concertImage,
      defaultUserSetting: {
        dashboard1DragCards: [
          { id: "ChatComponentDashboard" },
          { id: "IncomeAndExpensChart" },
          { id: "UpcomingBillsTable" },
          { id: "DashboardCalendar" },
          { id: "InvestmentWatchlistTable" },
          { id: "budgetExpanse" },
          { id: "goalProgress" },
          { id: "dashboardGoalCharts" },
          { id: "DashboardSavingsGoal" },
          { id: "PortfolioBalancesTable" },
          { id: "LatestNews" },
          { id: "topMonthlyExpanse" },
          { id: "TasksList" },
          { id: "dashboardGoalSection" },
          { id: "StoredDocumentsTable" },
          { id: "TwitterFeeds" },
        ],

        dashboard2DragCards: [
          { id: "UpcomingBillsTable" },
          { id: "dashboardGoalSection" },
          { id: "DashboardCalendar" },
          { id: "InvestmentWatchlistTable" },
          { id: "goalProgress" },
          { id: "PortfolioBalancesTable" },
          { id: "IncomeAndExpensChart" },
          { id: "ChatComponentDashboard" },
          { id: "dashboardGoalCharts" },
          { id: "DashboardSavingsGoal" },
          { id: "LatestNews" },
          { id: "budgetExpanse" },
          { id: "topMonthlyExpanse" },
          { id: "TasksList" },
          { id: "TwitterFeeds" },
          { id: "StoredDocumentsTable" },
        ],
        dashboard3DragCards: [
          { id: "topMonthlyExpanse" },
          { id: "DashboardSavingsGoal" },
          { id: "UpcomingBillsTable" },
          { id: "PortfolioBalancesTable" },
          { id: "dashboardGoalSection" },
          { id: "DashboardCalendar" },
          { id: "IncomeAndExpensChart" },
          { id: "goalProgress" },
          { id: "InvestmentWatchlistTable" },
          { id: "ChatComponentDashboard" },
          { id: "dashboardGoalCharts" },
          { id: "LatestNews" },
          { id: "budgetExpanse" },
          { id: "TasksList" },
          { id: "TwitterFeeds" },
          { id: "StoredDocumentsTable" },
        ],
      },
    },
    {
      title: "The Scholar",
      description: "Detail-Oriented Logical Prepared",
      image: education,
      route: "/dashboard",
      defaultUserSetting: {
        dashboard1DragCards: [],
        dashboard2DragCards: [],
        dashboard3DragCards: [],
      },
    },
    {
      title: "The Supporter",
      description: "Task-Oriented Stabilizing Cautious",
      image: peopleSadImage,
      route: "/dashboard",
      defaultUserSetting: {
        dashboard1DragCards: [],
        dashboard2DragCards: [],
        dashboard3DragCards: [],
      },
    },
  ];

  const setupDashboardSettingsForNewlyUser = async (payload) => {
    try {
      setLoading(true);
      const response = await DEATH_API.updateUserAssetSetting(payload);
    } catch (error) {
      console.error("Error updating user settings:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCardClick = (card) => {
    let payload = card.defaultUserSetting;
    // let payload = {};

    setupDashboardSettingsForNewlyUser(payload);
    history.push(card.route);
  };

  return (
    <div style={{position: "relative",}}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}>
        <div style={{ width: "80%", marginTop: "24px" }}>
          <h1 style={{ color: "#3d3dc9", fontSize: "24px" }}>
            Thoughtfully designed to naturally be the home base to go every
            morning and a perfect place to check throughout the day
          </h1>
          <h1 style={{ color: "#3d3dc9", fontSize: "20px" }}>
            In an effort to customize your dashboard experience, please tell
            what type of personality
          </h1>
        </div>
      </div>
      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontFamily: "Arial, sans-serif",
            margin: 0,
            flexWrap: "wrap",
            gap: "2rem",
            marginTop: "2rem",
            padding: "3rem",
          }}>
          {dashboardCardsData.map((card, index) => (
            <div
              key={index}
              onClick={() => handleCardClick(card)}
              className="navigate-page-card-container"
              style={{
                position: "relative",
                cursor: "pointer",
                width: "90%",
                maxWidth: "45%",
                overflow: "hidden",
                borderRadius: 10,
              }}>
              <div
                style={{
                  position: "absolute",
                  top: 20,
                  left: 20,
                  zIndex: 3,
                  textAlign: "left",
                  color: "black",
                }}>
                <h2
                  style={{
                    letterSpacing: "-1px",
                    fontSize: 24,
                    marginBottom: 5,
                    fontWeight: "bold",
                    textShadow: "2px 2px 3px #00000142",
                  }}>
                  {card.title}
                </h2>
                <p
                  style={{
                    width: "80%",
                    margin: "20px auto auto auto",
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                  }}>
                  {card.description}
                </p>
              </div>

              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                  zIndex: 2,
                }}></div>
              <div
                className="educationbackgroundImage"
                style={{
                  position: "relative",
                  width: "100%",
                  height: 200,
                  backgroundImage: `url(${card.image})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  zIndex: 1,
                }}></div>
            </div>
          ))}
        </div>
      </form>
      {loading ? (
        <div style={{ marginTop: "12px", display: "flex", justifyContent: "center", alignItems: "center", minHeight: "64px", borderRadius: "12px", border: "1px solid rgba(74, 98, 255, 0.35)", background: "linear-gradient(135deg, rgba(42, 61, 163, 0.16), rgba(42, 61, 163, 0.06))", boxShadow: "inset 0 1px 0 rgba(255,255,255,0.14)" }}>
          <Spin size="large" />
        </div>
      ) : null}
    </div>
  );
};

export default NewDashboardRoutePage;
